<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0049 18.3301C14.6082 18.3301 18.3399 14.5984 18.3399 9.99508C18.3399 5.39179 14.6082 1.66008 10.0049 1.66008C5.40163 1.66008 1.66992 5.39179 1.66992 9.99508C1.66992 14.5984 5.40163 18.3301 10.0049 18.3301ZM10.0552 5.23222C10.5166 5.23222 10.8907 5.60633 10.8907 6.06781L10.8907 11.0813C10.8907 11.5428 10.5166 11.9169 10.0552 11.9169C9.59367 11.9169 9.21956 11.5428 9.21956 11.0813L9.21956 6.06781C9.21956 5.60633 9.59367 5.23222 10.0552 5.23222ZM9.05232 13.7552C9.05232 14.3089 9.50125 14.7579 10.055 14.7579C10.6088 14.7579 11.0577 14.3089 11.0577 13.7552C11.0577 13.2014 10.6088 12.7525 10.055 12.7525C9.50125 12.7525 9.05232 13.2014 9.05232 13.7552Z"
      fill="currentColor"
    />
  </svg>
</template>
